// Detailed local SEO data per city (real neighborhoods, landmarks, context)
// Used by CityPage.jsx to build rich unique content per city

export const CITY_DETAILS = {
  "toulouse": {
    metaDescription: "Fasciathérapie à Toulouse et coach sport-santé à domicile, surtout Toulouse Est : Côte Pavée, Guilheméry, Soupetard, Montaudran, Rangueil. Bilan gratuit, 50% crédit d'impôt.",
    tagline: "Fasciathérapie et sport santé à domicile, de Toulouse Est au centre-ville",
    intro: "Basé aux portes de Toulouse Est, entre Saint-Orens et Quint-Fonsegrives, j'interviens en priorité dans les quartiers est de Toulouse (Côte Pavée, Guilheméry, Soupetard, Château de l'Hers, Montaudran) mais aussi au Capitole, à Rangueil ou à Saint-Cyprien. Fasciathérapie à Toulouse et coach sport-santé à domicile : je viens chez vous avec tout le matériel nécessaire.",
    districts: ["Côte Pavée", "Guilheméry", "Soupetard", "Château de l'Hers", "Capitole", "Saint-Cyprien", "Carmes", "Saint-Étienne", "Compans-Caffarelli", "Rangueil", "Empalot", "Minimes", "Purpan", "La Cépière", "Les Chalets", "Saint-Michel", "Croix-Daurade", "Jolimont"],
    landmarks: [
      { name: "Place du Capitole", desc: "Cœur historique — accompagnement à domicile dans les appartements du centre" },
      { name: "Canal du Midi", desc: "Idéal pour la marche active en complément des séances de mobilité" },
      { name: "Prairie des Filtres", desc: "Espace vert prisé pour la reprise du sport en douceur" },
      { name: "Quartier Rangueil / Université Paul Sabatier", desc: "Étudiants et enseignants-chercheurs souvent concernés par les tensions posturales" },
      { name: "Stade Ernest-Wallon", desc: "Sportifs en récupération après entraînement ou blessure" },
    ],
    why: [
      "Toulouse compte de nombreux actifs sédentaires — les tensions cervicales et lombaires sont fréquentes",
      "L'accès à Toulouse depuis Saint-Orens est rapide (30 min max en fonction du quartier)",
      "Je m'adapte à tous les logements toulousains : appartements haussmanniens, maisons de ville, résidences modernes",
      "Le coaching à domicile évite les embouteillages toulousains et le stress des déplacements",
    ],
    faq: [
      { q: "Quels quartiers de Toulouse desservez-vous ?", a: "Je me déplace dans tout Toulouse intra-muros : centre-ville, Saint-Cyprien, Rangueil, Minimes, Purpan, Carmes, Empalot, Compans-Caffarelli, Croix-Daurade, Jolimont, La Cépière et environs." },
      { q: "Y a-t-il un supplément pour Toulouse centre ?", a: "Non, aucun supplément. Le tarif est le même pour toute la métropole toulousaine desservie." },
    ],
  },

  "saint-orens": {
    metaDescription: "Fasciathérapie à Saint-Orens-de-Gameville (31650) et coach sport-santé à domicile. Cabinet 5 bis rue du Négoce ou chez vous : Corail, Marqueille, Belbèze. Bilan gratuit.",
    tagline: "Votre fasciathérapeute et coach sport-santé de proximité à Saint-Orens",
    intro: "Basé au cabinet du 5 bis rue du Négoce à Saint-Orens-de-Gameville, je vous propose la fasciathérapie à Saint-Orens (méthode Tissual Balancing) et un accompagnement de coach sport-santé à domicile pour vos douleurs chroniques, votre mobilité et la reprise d'une activité physique. De Fondargent-Corail à Belbèze, en passant par la place Jean Bellières (Altigone) et la route de Revel, je me déplace dans tous les quartiers saint-orennais.",
    districts: [
      "Centre-ville",
      "Fondargent-Corail",
      "Marqueille",
      "Belbèze",
      "Tucard",
      "Catala",
      "Bourdeau",
      "Route de Revel",
      "Place Jean Bellières",
    ],
    landmarks: [
      { name: "Cabinet 5 bis rue du négoce", desc: "Mon cabinet principal, accès facile et parking gratuit" },
      { name: "Salle Altigone (1 bis place Jean Bellières)", desc: "Salle de spectacle emblématique de Saint-Orens — repère culturel majeur" },
      { name: "Lycée Pierre-Paul Riquet", desc: "Seul lycée général et technologique de la commune — repère du quartier centre" },
      { name: "Secteur Fondargent-Corail", desc: "Quartier résidentiel avec écoles maternelle et élémentaire du Corail" },
      { name: "Route de Revel (D2)", desc: "Axe principal — accès rapide depuis Toulouse Est et Balma" },
      { name: "Marché du dimanche matin", desc: "Rendez-vous incontournable des Saint-Orennais" },
    ],
    why: [
      "Cabinet situé à Saint-Orens : évitez le déplacement si vous habitez à proximité",
      "Communauté locale attentive à la qualité de vie — mobilité et sport santé sont des priorités",
      "Beaucoup de familles avec enfants et de retraités actifs à Saint-Orens : programmes personnalisés",
      "Accès rapide vers Labège, Escalquens, Quint-Fonsegrives et le sud-est toulousain",
    ],
    faq: [
      { q: "Peut-on venir directement au cabinet à Saint-Orens ?", a: "Oui, le cabinet est situé au 5 bis rue du négoce, 31650 Saint-Orens-de-Gameville. Parking gratuit disponible à proximité." },
      { q: "Vous déplacez-vous dans tous les quartiers ?", a: "Oui, je me déplace dans tout Saint-Orens : Centre-ville, Fondargent-Corail, Marqueille, Belbèze, Tucard, Catala, Bourdeau, route de Revel et alentours de la place Jean Bellières." },
    ],
  },

  "quint-fonsegrives": {
    metaDescription: "Fasciathérapie à Quint-Fonsegrives (31130) et coach sport-santé à domicile : route de Castres, cours Goudouli et alentours. Méthode Tissual Balancing, bilan gratuit.",
    tagline: "Fasciathérapie et sport santé à Quint-Fonsegrives (31130)",
    intro: "Quint-Fonsegrives (31130) est ma commune de rattachement : je connais parfaitement ses rues, ses quartiers et ses habitants. De la route de Castres au cours Goudouli, en passant par les lotissements résidentiels du village, je me déplace quotidiennement chez vous : fasciathérapie à Quint-Fonsegrives pour soulager les douleurs chroniques, et séances de coach sport-santé à domicile pour retrouver mobilité et forme.",
    districts: [
      "Route de Castres",
      "Cours Goudouli",
      "Centre village",
      "Quartier de la Marqueille",
      "Chemin de Ribaute",
      "Chemin de Fonsegrives",
      "Domaine de la Salvetat",
    ],
    landmarks: [
      { name: "Route de Castres (D826)", desc: "Axe principal traversant la commune — proche des commerces et services locaux" },
      { name: "Cours Goudouli", desc: "Cœur commerçant de Quint-Fonsegrives — repère central du village" },
      { name: "Église Saint-Pierre", desc: "Édifice historique au centre du village" },
      { name: "Mairie de Quint-Fonsegrives", desc: "Place centrale de la vie communale" },
      { name: "Complexe sportif de la Marqueille", desc: "Équipements sportifs pour la reprise progressive de l'activité physique" },
      { name: "Domaine de la Salvetat", desc: "Quartier résidentiel calme, idéal pour les séances à domicile" },
    ],
    why: [
      "Je suis résident de Quint-Fonsegrives — accompagnement de proximité et grande disponibilité",
      "Commune prisée par les familles, cadres et retraités : besoins variés en sport santé",
      "Environnement calme et pavillonnaire, idéal pour la fasciathérapie à domicile",
      "Proximité immédiate avec Saint-Orens, Balma, Toulouse Est et Flourens",
    ],
    faq: [
      { q: "Vous êtes vraiment de Quint-Fonsegrives ?", a: "Oui, j'y réside — c'est ma commune de rattachement principale. Vous bénéficiez d'un accompagnement de proximité et d'une grande disponibilité, que vous soyez route de Castres, cours Goudouli ou dans les lotissements du village." },
      { q: "Vous vous déplacez dans tous les quartiers ?", a: "Oui, je me déplace dans tout Quint-Fonsegrives 31130 : route de Castres, cours Goudouli, quartier de la Marqueille, chemin de Ribaute, chemin de Fonsegrives et Domaine de la Salvetat." },
    ],
  },

  "balma": {
    metaDescription: "Fasciathérapie à Balma (31130) et coach sport-santé à domicile : Balma-Gramont, écoquartier Vidailhan, Lasbordes, Boville. Bilan gratuit, méthode Tissual Balancing.",
    tagline: "Votre praticien de proximité en Toulouse Est",
    intro: "Ville dynamique du Toulouse Est, Balma bénéficie du terminus de la ligne A du métro (Balma-Gramont) et concentre une population active variée. De l'écoquartier de Vidailhan à l'aérodrome de Lasbordes, en passant par le village historique de Boville, je viens à votre domicile pour des séances de fasciathérapie à Balma et un coaching sport-santé adapté, quel que soit votre quartier.",
    districts: [
      "Centre-ville",
      "Balma-Gramont",
      "Écoquartier de Vidailhan",
      "Lasbordes",
      "Boville",
    ],
    landmarks: [
      { name: "Métro Balma-Gramont (ligne A)", desc: "Terminus de la ligne A — hub de mobilité pour les Balmanais actifs à Toulouse" },
      { name: "Écoquartier de Vidailhan (31 ha)", desc: "Écoquartier labellisé — Maison de quartier avenue Galilée, parc de Vidailhan, jardin partagé Le Patus" },
      { name: "Aérodrome de Toulouse-Lasbordes", desc: "Site historique d'aviation générale — prairies classées ZNIEFF pour la marche" },
      { name: "Château de Thégra", desc: "Édifice patrimonial emblématique de Balma" },
      { name: "Église Saint-Martin de Boville", desc: "Cœur historique du village de Boville" },
      { name: "Centre commercial Balma-Gramont", desc: "Point de repère central près du terminus métro" },
    ],
    why: [
      "Balma concentre beaucoup d'actifs faisant la navette avec Toulouse — tensions cervicales fréquentes",
      "Écoquartier de Vidailhan : nombreuses jeunes familles avec enfants",
      "Accès rapide depuis mon cabinet de Saint-Orens (15 min en voiture)",
      "Terminus métro ligne A : idéal pour les personnes sans voiture",
    ],
    faq: [
      { q: "Desservez-vous Balma-Gramont et Vidailhan ?", a: "Oui, je me déplace dans tous les quartiers de Balma : Balma-Gramont, l'écoquartier de Vidailhan, Lasbordes, Boville, le centre-ville et alentours." },
    ],
  },

  "labege": {
    metaDescription: "Fasciathérapie à Labège (31670) et coach sport-santé à domicile. Séances à domicile pour cadres d'Enova, IoT Valley, Diagora et particuliers du village. Douleurs chroniques, sport santé.",
    tagline: "Bien-être et performance à Labège",
    intro: "Labège se structure autour de deux zones distinctes : le village historique et le pôle économique Enova (ex-Labège Innopole, renommé en 2017). Entre le Centre commercial Labège 2, l'IoT Valley (Sigfox, Donecle), le centre de congrès Diagora et l'église Saint-Barthélemy du village, je propose des séances de fasciathérapie et coaching adaptées à votre rythme, à domicile ou en entreprise.",
    districts: [
      "Labège-village",
      "Enova (ex-Innopole)",
      "IoT Valley",
      "Secteur Diagora",
      "Rue Pierre et Marie Curie",
    ],
    landmarks: [
      { name: "Enova (ex-Labège Innopole)", desc: "Grand pôle économique du Sicoval — cadres et ingénieurs souvent sédentaires" },
      { name: "IoT Valley", desc: "Cluster technologique hébergeant Sigfox, Donecle — profils tendus nuque/dos" },
      { name: "Diagora Congrès", desc: "Centre de congrès et d'exposition — repère majeur d'Enova" },
      { name: "Centre commercial Labège 2", desc: "Point de repère commercial majeur de la commune" },
      { name: "Église Saint-Barthélemy", desc: "Église néo-romane (1860-1880) au cœur du village historique" },
      { name: "Gare TER Labège-Innopole", desc: "Liaison rapide vers Toulouse Matabiau — future ligne C du métro (stations Labège Madron et Diagora)" },
    ],
    why: [
      "Population de cadres et ingénieurs très concernée par les TMS liées au bureau",
      "Séances possibles en entreprise sur les créneaux du déjeuner (Enova, IoT Valley)",
      "Accès très rapide depuis Saint-Orens (10 min)",
      "Approche adaptée au rythme professionnel intense",
    ],
    faq: [
      { q: "Intervenez-vous en entreprise à Labège Enova ?", a: "Oui, je propose des séances individuelles à domicile ou directement sur le lieu de travail (créneau déjeuner, avant ou après vos horaires), dans les zones Enova, IoT Valley et autour de Diagora. Contactez-moi pour organiser cela." },
      { q: "Desservez-vous aussi le village de Labège ?", a: "Bien sûr, je me déplace dans tout Labège 31670, du village historique (autour de l'église Saint-Barthélemy) jusqu'à la zone Enova et le secteur Diagora." },
    ],
  },

  "montaudran": {
    metaDescription: "Fasciathérapie à Montaudran (Toulouse Est, 31400) et coach sport-santé à domicile. Séances à domicile près de la Halle de la Machine, ZAC Aerospace, campus universitaire. Bilan gratuit.",
    tagline: "Sport santé au quartier de l'Aéropostale",
    intro: "Montaudran, quartier historique de l'Aéropostale devenu pôle d'innovation aérospatiale, mêle habitants historiques, jeunes chercheurs et ingénieurs. Que vous soyez proche de la Halle de la Machine, du campus universitaire ou de la ZAC Aerospace, je viens à votre domicile pour vous accompagner en fasciathérapie et sport santé.",
    districts: ["Ancien aérodrome", "ZAC Montaudran Aerospace", "Piste des Géants", "Guilheméry proche", "Saouzelong"],
    landmarks: [
      { name: "Halle de la Machine", desc: "Emblème culturel du quartier — accessible à pied depuis la plupart des logements" },
      { name: "Piste des Géants", desc: "Grand espace public — idéal pour la marche active" },
      { name: "ZAC Montaudran Aerospace", desc: "Nouveaux logements pour jeunes actifs et familles" },
      { name: "Université Toulouse III (proche)", desc: "Étudiants, doctorants, enseignants souvent concernés" },
      { name: "Ancien aérodrome de Montaudran", desc: "Berceau de l'Aéropostale — parc historique aménagé" },
    ],
    why: [
      "Quartier en pleine expansion avec une forte proportion de jeunes actifs sédentaires",
      "Proximité du campus universitaire : nombreux étudiants et chercheurs",
      "Accès direct depuis Saint-Orens par la rocade (10-15 min)",
      "Population sensible au bien-être et à l'activité physique adaptée",
    ],
    faq: [
      { q: "Desservez-vous le nouveau quartier Aerospace ?", a: "Oui, je me déplace dans toute la ZAC Montaudran Aerospace, autour de la Piste des Géants et dans les quartiers résidentiels adjacents (Guilheméry, Saouzelong)." },
    ],
  },
};
